(() => {
  'use strict';

  const initCommercialPage = root => {
    if (!root || root.dataset.seqCommercialReady === 'true') return;
    root.dataset.seqCommercialReady = 'true';

    root.querySelectorAll('[data-commercial-ba]').forEach(stage => {
      const range = stage.querySelector('[data-commercial-ba-range]');
      if (!range) return;

      const update = () => {
        stage.style.setProperty('--seq-commercial-ba', `${range.value}%`);
      };

      range.addEventListener('input', update);
      update();
    });

    const quote = root.querySelector('#commercial-quote');
    const mobileCta = root.querySelector('[data-commercial-mobile-cta]');

    if (quote && mobileCta && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            mobileCta.classList.toggle('is-hidden', entry.isIntersecting);
          });
        },
        { threshold: 0.08 }
      );

      observer.observe(quote);
    }

    const success = root.querySelector('[data-commercial-success]');
    if (success) {
      requestAnimationFrame(() => {
        success.focus({ preventScroll: true });
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  };

  const initAll = () => {
    document.querySelectorAll('[data-seq-commercial]').forEach(initCommercialPage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll?.('[data-seq-commercial]').forEach(initCommercialPage);
  });
})();
